import styled from 'styled-components';

export const SideMenuSpacer = styled.div`
	flex-grow: 1;
	background-color: transparent;
	padding: 0;
	margin: 0;
	list-style-type: none;
`;
